// extracted by mini-css-extract-plugin
export default {"msgM":"e08968b63d"};